import { instance } from './Axios';

export const deleteFile = async (id?: string) => {
  const response = await instance.delete(`/files/${id}`);
  return response.data;
};
